<template>
  <Button
    v-if="showLabel && visibility"
    class="map-button"
    :size="size ?? undefined"
    :disabled="disabled"
    :severity="computedSeverity"
    @click.prevent="clickFn"
    v-tooltip:[pos]="{ value: translatedDescription, escape: true }"
    :style="{ ...(buttonStyle ?? {}) }"
  >
    <img
      :src="icon"
      :alt="$t(label)"
      :class="size"
      :style="{ filter: isActive ? 'invert(100%)' : 'grayscale(100%)', ...(iconStyle ?? {}) }"
    />
    <span class="mx-1 p-button-label">{{ $t(label) }}</span>
  </Button>
  <Button
    v-if="!showLabel && visibility"
    class="map-button"
    v-tooltip:[pos]="{ value: translatedDescription, escape: true }"
    :size="size ?? undefined"
    :disabled="disabled"
    :severity="computedSeverity"
    @click.prevent="clickFn"
  >
    <img
      :src="icon"
      :alt="$t(label)"
      :class="{ 'pi-spin': spin }"
      :style="{ filter: isActive ? 'invert(100%)' : 'grayscale(100%)', ...(computedIconStyle ?? {}) }"
    />
  </Button>
</template>
<script>
import { colorToFilter } from '@/js/plugins/tintFilter';
import Button from 'primevue/button';
import { MapEvent } from '../../js/document/model/map';

export default {
  name: 'MapButton',
  components: { Button },
  computed: {
    /*computedButtonStyle(){
      if(typeof this.buttonStyle === 'string') return JSON.parse(this.buttonStyle.replaceAll('\n',''))
      else return this.buttonStyle;
    },
    computedIconStyle(){
    if(typeof this.iconStyle === 'string') return JSON.parse(this.iconStyle.replaceAll('\n',''))
      else return this.iconStyle;
    },*/
    computedSeverity() {
      if (this.severity) {
        return this.severity;
      }
      if (this.isActive) {
        return `primary`;
      }
      return `secondary`;
    },
    translatedDescription() {
      return this.$t(this.description ?? this.label);
    },
  },
  props: {
    mapController: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
    },
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: true,
    },
    severity: {
      type: String,
    },
    active: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    size: {
      type: String,
    },
    buttonStyle: {
      type: Object,
    },
    iconStyle: {
      type: Object,
    },
    tooltipPosition: {
      type: String,
      default: 'top',
    },
    spin: {
      type: Boolean,
      default: false,
    },
    action: {
      type: Object,
    },
    visibility: {
      type: Boolean,
      default: true,
    },
    pos: {
      type: Object,
      default: ()=>{
        return {
          position: 'right'
        }
      }
    }
  },
  data(){
    return {
      isActive:false

    }
  },
  mounted() {
    if (this.active && !this.mapController?.interaction.activeCustomControl && this.id){
      this.mapController.interaction.activeCustomControl = this.id;
    }

    this.mapController?.mapInstance?.on(MapEvent.ToggleCustomMapButton, this.toggleCustomMapButton)
    this.isActive = this.active;
  },
  methods: {
    colorToFilter,
    clickFn(event) {
      if (this.action)
        this.mapController.mapInstance.fire(MapEvent.CustomButtonActioned, { action: this.action, id: this.id});
      this.$emit('action', event, this.action, this.id);

    },
    toggleCustomMapButton(event){
      if(this.id === event.id){
        this.isActive = event.active ?? true
        //this.$forceUpdate();
      }
      else this.isActive = this.active
    }
  },
  watch: {
    visibility() {
    },
    active(){
      this.isActive = this.active
    }

  },
  created() {},

};
</script>
<style lang="scss">
.map-button {
  .p-button-label {
    font-size: revert !important;
  }
  .small {
    width: 30px;
    height: 30px;
  }
}
</style>
